import { render, staticRenderFns } from "./Saml.vue?vue&type=template&id=e836272c&scoped=true"
import script from "./Saml.vue?vue&type=script&lang=ts"
export * from "./Saml.vue?vue&type=script&lang=ts"
import style0 from "./Saml.vue?vue&type=style&index=0&id=e836272c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e836272c",
  null
  
)

export default component.exports